module.exports = __webpack_public_path__ + "img/chevron-back-outline.019164dd.svg";